
import Vue from 'vue';
import VueRouter from 'vue-router';
import store from './store/index.js';
import Login from '@/js/components/Login';
const PasswordUpdate = () => import('./pages/profile/PasswordUpdate');
const TwoFactorSetup = () => import('./pages/profile/TwoFactorSetup');
const TwoFactorVerify = () => import('./pages/auth/TwoFactorVerify');
const Dashboard = () => import('./components/Dashboard');
const Users = () => import('./components/users/Users');
const UserList = () => import('./components/users/UserList');
const UserAdd = () => import('./components/users/UserAdd');
const UserEdit = () => import('./components/users/UserEdit');
const Integrations = () => import('./components/integrations/Integrations');
const IntegrationsList = () => import('./components/integrations/IntegrationsList');
const IntegrationsAdd = () => import('./components/integrations/IntegrationsAdd');
import IntegrationsEdit from '@/js/components/integrations/IntegrationsEdit';
import IntegrationsView from '@/js/components/integrations/IntegrationsView';
const Accounts = () => import('./components/accounts/Accounts');
const AccountList = () => import('./components/accounts/AccountList');
const AccountAdd = () => import('./components/accounts/AccountAdd');
const AccountEdit = () => import('./components/accounts/AccountEdit');
const Logs = () => import('./components/logs/Logs');
const LogSyncs = () => import('./components/logs/LogSyncs');
const RecordView = () => import('./components/logs/RecordView');
const RecordReprocess = () => import('./components/logs/RecordReprocess');
// const BulkItems = () => import('./components/bulk-items/index');
// const BulkPickslips = () => import('./components/bulk-pickslips/index');
const Platforms = () => import('./components/platforms/index');
const PlatformList = () => import('./components/platforms/PlatformList');
const PlatformView = () => import('./components/platforms/PlatformEdit');
import Liverates from '@/js/components/liverates/index';
import LiveratesLogs from '@/js/components/liverates/LiveratesLogs';
const LiveratesData = () => import('./components/liverates/LiveratesData');
const Magento2OAuth = () => import('./components/magento/Magento2OAuth');

const WebHooks = () => import('./components/webhooks/index');
const WebHooksLogs = () => import('./components/webhooks/Logs');

const NotFound = () => import('./components/404');
const Maintenance = () => import('./components/503');

const localPrefix = window.IS_LOCAL ? "[LOCAL] ":"";

Vue.use(VueRouter);

const appName = `${localPrefix}MachShip Integrations`;
const metaGuest = { title: appName, guest: true, layout: 'no-sidebar-layout' }
const metaAuth  = { title: appName, requiresAuth: true, layout: 'default-layout' }
const rolesSuperAdmin = ['Super Admin'];
const rolesAdmin = ['Super Admin', 'Admin'];

const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/login',
            name: 'login',
            component: Login,
            meta: metaGuest
        },
        {
            path: '/verify',
            name: 'two-factor-verify',
            component: TwoFactorVerify,
            meta: { ...metaGuest, title: 'Two-Factor Authentication - ' + appName }
        },
        {
            path: '/',
            name: 'dashboard',
            component: Dashboard,
            meta: Object.assign({...metaAuth}, {title: 'Dashboard  - ' + appName})
        },
        {
            path: '/users',
            name: 'users',
            component: Users,
            meta: Object.assign({...metaAuth}, {roles: rolesAdmin}),
            children: [
                {
                    path: '',
                    component: UserList,
                    meta: { title: 'User List - ' + appName },
                    name: 'user list'
                },
                {
                    path: 'add',
                    component: UserAdd,
                    meta: { title: 'User Add - ' + appName },
                    name: 'user add'
                },
                {
                    path: ':id',
                    component: UserEdit,
                    meta: { title: 'User Edit - ' + appName },
                    name: 'user edit'
                }
            ]
        },
        {
            path: '/accounts',
            component: Accounts,
            name: 'accounts',
            meta: Object.assign({...metaAuth}, {roles: rolesSuperAdmin}),
            children: [
                {
                    path: '',
                    name: 'account list',
                    meta: { title: 'Account List - ' + appName },
                    component: AccountList,
                },
                {
                    path: 'add',
                    name: 'account add',
                    meta: { title: 'Account Add - ' + appName },
                    component: AccountAdd,
                },
                {
                    path: ':id',
                    name: 'account edit',
                    meta: { title: 'Account Edit - ' + appName },
                    component: AccountEdit,
                }
            ]
        },

        {
            path: '/integrations',
            component: Integrations,
            name: 'integrations',
            // meta: Object.assign({...metaAuth}, {roles: rolesSuperAdmin}),
            children: [
                {
                    path: '',
                    name: 'integrations list',
                    meta: Object.assign({...metaAuth}, { title: 'Integrations List - ' + appName }),
                    component: IntegrationsList,
                },
                {
                    path: 'add',
                    component: IntegrationsAdd,
                    meta: Object.assign({...metaAuth}, {roles: rolesSuperAdmin, title: 'Integration Add - ' + appName }),
                    name: 'integration add'
                },
                {
                    path: ':id',
                    component: IntegrationsEdit,
                    meta: Object.assign({...metaAuth}, {roles: rolesSuperAdmin, title: 'Integration Edit - ' + appName }),
                    name: 'integration edit'
                },
                {
                    path: ':id/view',
                    component: IntegrationsView,
                    meta: Object.assign({...metaAuth}, { title: 'Integration View - ' + appName }),
                    name: 'integration view'
                },
            ]
        },

        {
            path: '/logs',
            name: 'logs',
            component: Logs,
            children: [
                {
                    path: '',
                    component: LogSyncs,
                    meta: Object.assign({...metaAuth}, { title: 'Sync Record Logs  - ' + appName }),
                    name: 'Sync Record Logs'
                },
                {
                    path: ':id',
                    component: RecordView,
                    meta: Object.assign({...metaAuth}, { title: 'View Record  - ' + appName }),
                    name: 'view Records'
                },
                {
                    path: ':id/reprocess',
                    component: RecordReprocess,
                    meta: Object.assign({...metaAuth}, { title: 'Reprocess Record  - ' + appName }),
                    name: 'Reprocess Records'
                },
            ]
        },

        // {
        //     path: '/bulk-items',
        //     name: 'bulk items',
        //     component: BulkItems,
        //     meta: Object.assign({...metaAuth}, { title: 'Bulk Items - ' + appName }),
        // },

        // {
        //     path: '/bulk-pickslips',
        //     name: 'bulk pickslips',
        //     component: BulkPickslips,
        //     meta: Object.assign({...metaAuth}, { title: 'Bulk Pickslips - ' + appName }),
        // },

        {
            path: '/live-rates',
            name: 'Live Rates',
            component: Liverates,
            meta: Object.assign({...metaAuth}, { title: 'Live Rates  - ' + appName }),
            children: [
                {
                    path: '',
                    redirect: 'logs'
                },
                {
                    path: 'logs',
                    name: 'Live Rates Logs',
                    meta: Object.assign({...metaAuth}, { title: 'Live Rates Logs - ' + appName }),
                    component: LiveratesLogs,
                },
                {
                    path: 'logs/:id',
                    name: 'Live rates data',
                    meta: Object.assign({...metaAuth}, { title: 'Live Rates Json Data - ' + appName }),
                    component: LiveratesData,
                }
            ]
        },

        {
            path: '/webhooks',
            name: 'Web Hooks Logs',
            component: WebHooks,
            children: [
                {
                    path: '',
                    redirect: 'logs'
                },
                {
                    path: 'logs',
                    name: 'Web Hooks Logs',
                    meta: Object.assign({...metaAuth}, { title: 'Web Hooks Logs  - ' + appName }),
                    component: WebHooksLogs
                }
            ]
        },

        {
            path: '/platforms',
            component: Platforms,
            name: 'platforms',
            meta: Object.assign({...metaAuth }, { title: 'Platforms  - ' + appName, roles: rolesAdmin }),
            children: [{
                    path: '',
                    name: 'Platform List',
                    meta: Object.assign({...metaAuth }, { title: 'Platform List - ' + appName }),
                    component: PlatformList,
                },
                {
                    path: ':id',
                    name: 'Platform View',
                    meta: Object.assign({...metaAuth }, { title: 'Platform View - ' + appName }),
                    component: PlatformView
                }
            ]
        },

        {
            path: '/profile/password',
            name: 'password-update',
            component: PasswordUpdate,
            meta: Object.assign({...metaAuth}, {title: 'Update Password - ' + appName})
        },
        {
            path: '/profile/2fa',
            name: 'two-factor-setup',
            component: TwoFactorSetup,
            meta: Object.assign({...metaAuth}, {title: 'Two-Factor Authentication - ' + appName})
        },
        {
            path: '/maintenance',
            meta: { layout: 'no-sidebar-layout' },
            component: Maintenance
        },


        {
            path: '/magento2/oauth',
            name: 'Magento OAuth',
            meta: Object.assign({...metaAuth }, { title: 'Magento OAuth  - ' + appName }),
            component: Magento2OAuth
        },

        {
            path: '*',
            component: NotFound
        }
    ]
});

router.beforeEach((to, from, next) => {

    // This goes through the matched routes from last to first, finding the closest route with a title.
    // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
    const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

    // If a route with a title was found, set the document (page) title to that value.
    if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (localStorage.getItem('jwt') != null && store.state.user.id == null) {
            /*
            Watch for the user to be loaded. When it's finished, then
            we proceed.
            */
            store.watch( (state) => {
                return state.user
            }, function(newUser) {
                checkPermission(to, from, next, newUser);
            });
        } else {
            let user = store.state.user
            checkPermission(to, from, next, user)
        }
    } else if(to.matched.some(record => record.meta.guest)) {
        if(localStorage.getItem('jwt') == null){
            next()
        } else{
            next({ name: 'dashboard'})
        }
    } else {
        next()
    }
});


// check role position
const checkPermission = (to, from, next, user) => {
    if (to.matched.some(record => record.meta.roles)) {
        // now validate roles if this routes accept user role
        if (
            to.matched.some(
                record =>
                    record.meta.roles &&
                    record.meta.roles.indexOf(user.roles[0]) >= 0
            )
        ) {
            next()
        // otherwise, redirect back to dashboard
        } else {
            next({ name: 'dashboard'})
        }
    } else {
        next()
    }
}

export default router;
